<div class="assign-users-dialog">
  <div class="dialog-content">
    @if (dataLoaded) {
      <div class="form-container">
        <!-- Add Mode: User Selection Section -->
        @if (!isEditMode) {
          <div class="field">
            <label for="userSelect" class="modal-label">Select Users</label>
            <p-multiSelect
              id="userSelect"
              [options]="availableUsers"
              [(ngModel)]="selectedUserIds"
              (onChange)="onUserSelectionChange()"
              optionLabel="displayLabel"
              optionValue="userId"
              placeholder="Choose users to assign"
              [showToggleAll]="false"
              [showHeader]="true"
              [filter]="true"
              filterBy="displayLabel"
              class="w-100"
              [style]="{ width: '100%' }"
              [disabled]="isSaving || isProcessingAny"
              appendTo="body">
            </p-multiSelect>
          </div>

          @if (selectedUserIds.length > 0) {
            <div class="selected-count">
              <small>{{ selectedUserIds.length }} user(s) assigned</small>
            </div>
          }
        }

        <!-- Edit Mode: Single User Info -->
        @if (isEditMode && editUser) {
          <div class="edit-user-section">
            <div class="user-info-card">
              <div class="mb-3">
                <label class="modal-label">User</label>
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-user text-xl text-500"></i>
                  <div>
                    <div class="font-semibold">{{ editUser.firstName }} {{ editUser.lastName }}</div>
                    <div class="text-sm text-500">{{ editUser.email }}</div>
                  </div>
                </div>
              </div>
              <div class="field">
                <label for="editRole" class="modal-label">Role</label>
                <p-select
                  id="editRole"
                  [options]="getAssignableRolesForUser(editUser.userId!, editUser.roleId)"
                  [(ngModel)]="editUser.roleId"
                  optionLabel="roleName"
                  optionValue="roleId"
                  placeholder="Select Role"
                  [style]="{ width: '100%' }"
                  [disabled]="isSaving"
                  appendTo="body">
                </p-select>
              </div>
            </div>
          </div>
        }

        <!-- Add Mode: User Assignments List -->
        @if (!isEditMode) {
          @if (userAssignments.length > 0) {
            <div class="user-assignments">
              @for (assignment of userAssignments; track assignment.userId; let i = $index) {
	                <div class="user-row">
	                  <div class="user-info">
	                    <span class="user-email">{{ assignment.email }}</span>
	                  </div>
	                  <div class="role-dropdown">
                    <p-select
                      [options]="getAssignableRolesForUser(assignment.userId, assignment.roleId)"
                      [(ngModel)]="assignment.roleId"
                      optionLabel="roleName"
                      optionValue="roleId"
	                      placeholder="Select Role"
	                      [style]="{ width: '150px' }"
	                      [disabled]="isSaving || !!assignment.isProcessing"
	                      appendTo="body">
	                    </p-select>
		                  </div>
	                  <div class="row-actions">
	                    <p-button
	                      icon="pi pi-trash"
	                      [text]="true"
	                      [rounded]="true"
		                      severity="danger"
	                      (onClick)="removeUser(i)"
	                      [disabled]="isSaving || !!assignment.isProcessing"
	                      [loading]="!!assignment.isProcessing"
	                      pTooltip="Remove user">
	                    </p-button>
                  </div>
	                </div>
	              }
	            </div>
	          }

          <!-- Empty State -->
          @if (userAssignments.length === 0) {
            <div class="empty-state">
              <i class="pi pi-users text-4xl text-400 mb-2"></i>
              <p class="text-600">No users assigned yet</p>
              <p class="text-500 text-sm">Select users from the dropdown above to add them to the project</p>
            </div>
          }
        }
      </div>
    }
  </div>

	  <div class="dialog-footer">
	    <p-button
	      label="Close"
	      icon="pi pi-times"
	      [outlined]="true"
	      (onClick)="cancel()"
	      [disabled]="isSaving || isProcessingAny">
	    </p-button>

	    @if (!isEditMode) {
	      <p-button
	        label="Save"
	        icon="pi pi-check"
	        (onClick)="saveAllRoleChanges()"
	        [disabled]="!dataLoaded || !hasPendingRoleChanges || isSaving || isProcessingAny"
	        [loading]="isSaving">
	      </p-button>
	    }

	    @if (isEditMode) {
	      <p-button
	        label="Save"
	        icon="pi pi-check"
	        (onClick)="save()"
	        [disabled]="!dataLoaded || isSaving"
	        [loading]="isSaving">
	      </p-button>
	    }
	  </div>
</div>
